import { createContext, useContext } from 'react';

const recognizeValueNeverProvided = {};

export const createProvider = <T extends unknown = unknown>(
  defaultValue = recognizeValueNeverProvided as T,
  name?: string
) => {
  const Context = createContext(defaultValue);

  return {
    Provider: Context.Provider,

    useValue: () => {
      const value = useContext(Context);

      if (value === recognizeValueNeverProvided)
        throw Error(
          `The value for the provider${name ? ` "${name}"` : ''} has never been provided`
        );

      return value;
    },
  };
};
